import httpClient from "../config/httpClient";
import { SaleProcessFiltersDto } from "@/api/models/saleProcess.model";
import { SaleProcessStatusType } from "@/constants/sale-process.constants";
import { mapSaleProcessFiltersDtoToQuery } from "../adapters/saleProcess.adapter";
import { DashboardTotalDto } from "../models/common.model";

export abstract class SaleProcessService {
	private static readonly SALE_PROCESS_URL = "/sys03/sale-process";

	private static readonly ADDITIONAL_CONTACT = "additional-contact";
	private static readonly ADDITIONAL_CONTACTS = "additional-contacts";

	private static readonly DASHBOARD_URL = SaleProcessService.SALE_PROCESS_URL.concat("/dashboard");
	private static readonly DASHBOARD_COUNT_URL = SaleProcessService.DASHBOARD_URL.concat("/count");
	private static readonly DASHBOARD_CSV_URL = SaleProcessService.DASHBOARD_URL.concat("/csv");

	// Additional contacts

	public static getAdditionalContacts(saleProcessId: string) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${saleProcessId}/${SaleProcessService.ADDITIONAL_CONTACTS}`;
		return httpClient.get(url);
	}

	public static postAdditionalContact(saleProcessId: string, additionalContact: any) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${saleProcessId}/${SaleProcessService.ADDITIONAL_CONTACT}`;
		return httpClient.post(url, additionalContact);
	}

	public static putAdditionalContact(saleProcessId: string, additionalContact: any) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${saleProcessId}/${SaleProcessService.ADDITIONAL_CONTACT}/${additionalContact.id}`;
		return httpClient.put(url, additionalContact);
	}

	public static deleteAdditionalContact(saleProcessId: string, additionalContactId: string) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${saleProcessId}/${SaleProcessService.ADDITIONAL_CONTACT}/${additionalContactId}`;
		return httpClient.delete(url);
	}

	// Files

	public static downloadContract({ id }: { id: number }) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${id}/contract/download`;
		return httpClient.get(url, { responseType: "blob" });
	}

	public static getDashboardInformation(filters: SaleProcessFiltersDto) {
		const url = `${SaleProcessService.DASHBOARD_URL}`;
		const params = mapSaleProcessFiltersDtoToQuery({ filters });

		return httpClient.get(url, { params });
	}

	public static getDashboardCsv(filters: SaleProcessFiltersDto) {
		const url = `${SaleProcessService.DASHBOARD_CSV_URL}`;
		const params = mapSaleProcessFiltersDtoToQuery({ filters: { ...filters, page: 1, limit: -1 } });

		return httpClient.get(url, { params });
	}

	public static getLeadHistoryCsv(id: any) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${id}/history/csv`;
		return httpClient.get(url);
	}

	public static getDashboardTodayStats({ status }: { status: SaleProcessStatusType }) {
		const today = new Date().toISOString().substring(0, 10);

		const url = `${SaleProcessService.DASHBOARD_COUNT_URL}`;
		return httpClient
			.get<DashboardTotalDto>(url, {
				params: {
					status,
					dateFrom: today,
					dateTo: today
				}
			})
			.then((response) => response.data);
	}

	public static getDashboardThisMonthStats({ status }: { status: SaleProcessStatusType }) {
		const date = new Date();
		const currentMonth = date.getMonth();
		const currentYear = date.getFullYear();

		const dateFrom = new Date(currentYear, currentMonth, 2).toISOString().substring(0, 10);
		const dateTo = new Date(currentYear, currentMonth + 1, 1).toISOString().substring(0, 10);

		const url = `${SaleProcessService.DASHBOARD_COUNT_URL}`;
		return httpClient
			.get<DashboardTotalDto>(url, {
				params: {
					status,
					dateFrom,
					dateTo
				}
			})
			.then((response) => response.data);
	}

	public static checkForbiddenStatus(id: number) {
		const url = `${SaleProcessService.SALE_PROCESS_URL}/${id}/check-forbidden-status`;
		return httpClient.get(url);
	}
}
